<template>
    <div v-if="dados && dados.cadastro"> 
        <div v-if="super_resumo">
            <div class="d-flex justify-content-between">
                <div class="d-flex align-items-end">
                    <h4 class="border-0 mb-0">
                        <a class="card-link small mr-2" data-toggle="collapse" href="#collapseExample" @click.prevent="show_dados = !show_dados" role="button" aria-expanded="false" aria-controls="collapseExample">
                            <i class="fas fa-caret-down"></i>
                        </a>
                        {{ get_nome_bb(dados.search) }} 
                        <span class="small">
                            {{ get_nome_bb(dados.search, false) }}
                        </span>
                    </h4>

                    <span class="small mb-0 ml-3" v-if="plano">
                        {{ plano.search }}
                    </span>
                </div>
                <div class="d-flex flex-column flex-md-row">
                    <span class="text-right"> 
                        <az-paciente-propriedades :paciente="dados"></az-paciente-propriedades>
                    </span>
                    <span class="text-right">
                        <span>
                            <span title="Sexo">
                                {{ sexo (dados.cadastro.ch_sexo) }}, 
                            </span>
                            <span v-if="dados.cadastro.dt_nascimento" title="Data de Nascimento">
                                {{ $util.getFormatDate (dados.cadastro.dt_nascimento) }}, 
                            </span>
                            <span title="Idade">
                                {{ dados.cadastro.idade }}
                            </span>
                        </span>
                        <div>
                            <span v-if="dados.cidade" class="mx-2">
                                {{ dados.cidade.search }}
                                <span class="ml-2" v-if="campos_customizados.length">/</span>
                            </span>
                            <span v-for="(campo, icx) in campos_customizados" :key="icx" :title="campo.label">
                                <span v-if="icx" class="mx-2">/</span>
                                <span v-if="campo.value && !isNaN(campo.value)">{{ campo.label }}:</span>
                                {{ campo.value }}
                            </span>
                        </div>
                    </span>
                    <span class="text-right">
                        <span v-for="(tel, it) in telefones" :key="it" class="ml-3">
                            <i class="fas fa-phone mr-1" v-if="tel.telefone.ch_tipo_telefone == 'R'"></i>
                            <i class="fas fa-mobile-alt mr-1" v-if="tel.telefone.ch_tipo_telefone == 'M'"></i>
                            <span>
                                {{ telefone(tel.telefone) }}
                            </span>
                        </span>
                    </span>
                </div>
            </div>

            <div class="text-danger ml-4" v-if="dados && dados.alergias && dados.alergias.length">
                <strong>Alergias:</strong>
                <span class="ml-1">{{ dados.alergias.map(alergia => ( alergia.tipo.search == 'Outras' && alergia.st_observacoes ) ? alergia.st_observacoes : alergia.tipo.search).join(', ') }}</span>
            </div>

            <div class="ml-4" v-if="dados && dados.paciente_unidade && dados.paciente_unidade.js_classes && dados.paciente_unidade.js_classes.length">
                <span class="badge badge-success mr-1" v-for="(classe, icx) in dados.paciente_unidade.js_classes" :key="icx">{{ classe }}</span>
            </div>
        </div>
        <div class="card" style="padding: 0px;" :class="super_resumo ? 'mb-2' : ''" v-if="dados && dados.cadastro">
            <template v-if="!panel">
                <div class="card-header pb-1" v-if="!super_resumo">
                    <div v-if="dados.st_nome" class="d-flex justify-content-between flex-column flex-md-row">
                        <div v-if="!panel" class="mb-2">
                            <h1 class="border-0 mb-0">
                                <a href="#" @click.prevent="$root.perfil(dados)" class="card-link mr-2" v-if="dados.id_pessoa">
                                    <i class="fa-solid fa-id-badge"></i>
                                </a>
                                {{ get_nome_bb(dados.search) }} 
                                <div class="small ml-5" style="font-size: 0.875rem; font-weight: normal; line-height: normal;" v-if="get_nome_bb(dados.search, false)">
                                    {{ get_nome_bb(dados.search, false) }}
                                </div>
                            </h1>

                            <div class="text-danger ml-4" v-if="dados && dados.alergias && dados.alergias.length">
                                <strong>Alergias:</strong>
                                <span class="ml-1">{{ dados.alergias.map(alergia => alergia.tipo.search).join(', ') }}</span>
                            </div>

                            <div>
                                <!-- 
                                <a class="card-link small" data-toggle="collapse" href="#collapseExample" role="button" aria-expanded="false" aria-controls="collapseExample">
                                    Dados Cadastrais
                                    <i class="fas fa-caret-down"></i>
                                </a>
                                -->
                                <a class="card-link small" @click.prevent="show_dados = !show_dados" href="#">
                                    Dados Cadastrais
                                    <i class="fas fa-caret-down"></i>
                                </a>
                                <span class="small text-muted ml-3" v-if="plano">
                                    {{ plano.search }}
                                </span>

                                <span class="ml-4" v-if="dados && dados.paciente_unidade && dados.paciente_unidade.js_classes && dados.paciente_unidade.js_classes.length">
                                    <span class="badge badge-success mr-1" v-for="(classe, icx) in dados.paciente_unidade.js_classes" :key="icx">{{ classe }}</span>
                                </span>
                            </div>
                        </div>
                        <div class="mb-2" v-else>
                            &nbsp;
                        </div>
                        <div class="d-flex flex-column flex-md-row">
                            <span class="text-right"> 
                                <az-paciente-propriedades :paciente="dados"></az-paciente-propriedades>
                            </span>
                            <span class="text-right">
                                <small>
                                    <span title="Sexo">
                                        {{ sexo (dados.cadastro.ch_sexo) }}, 
                                    </span>
                                    <span v-if="dados.cadastro.dt_nascimento" title="Data de Nascimento" :class="dados.cadastro.dt_nascimento.slice(5,9) == $util.hoje().slice(5,9) ? 'font-weight-bold text-success' : ''">
                                        {{ $util.getFormatDate (dados.cadastro.dt_nascimento) }}, 
                                        <i class="fa-solid fa-cake-candles text-success" v-if="dados.cadastro.dt_nascimento.slice(5,9) == $util.hoje().slice(5,9)"></i>
                                    </span>
                                    <span title="Idade" class="text-nowrap">
                                        {{ dados.cadastro.idade }}
                                    </span>
                                </small>
                                <div class="small">
                                    <span v-if="dados.cidade" class="mx-2">
                                        {{ dados.cidade.search }}
                                        <span class="ml-2" v-if="campos_customizados.length">/</span>
                                    </span>
                                    <span v-for="(campo, icx) in campos_customizados" :key="icx" :title="campo.label">
                                        <span v-if="icx" class="mx-2">/</span>
                                        <span v-if="campo.value && !isNaN(campo.value)">{{ campo.label }}:</span>
                                        {{ campo.value }}
                                    </span>
                                </div>
                            </span>
                            <span class="ml-3 text-right">
                                <div  v-for="(tel, it) in telefones" :key="it" class="text-nowrap">
                                    <i class="fas fa-phone mr-1" v-if="tel.telefone.ch_tipo_telefone == 'R'"></i>
                                    <i class="fas fa-mobile-alt mr-1" v-if="tel.telefone.ch_tipo_telefone == 'M'"></i>
                                    <small>
                                        {{ telefone(tel.telefone) }}
                                    </small>
                                </div>
                            </span>
                        </div>
                    </div>
                </div>
            </template>
            <div class="card-header d-flex justify-content-between" v-else>
                <span>
                    <!-- 
                    <a class="card-link small" data-toggle="collapse" href="#collapseExample" role="button" aria-expanded="false" aria-controls="collapseExample">
                        Dados Cadastrais
                        <i class="fas fa-caret-down"></i>
                    </a>
                    -->

                    <a class="card-link small" @click.prevent="show_dados = !show_dados" href="#">
                        Dados Cadastrais
                        <i class="fas fa-caret-down"></i>
                    </a>


                    <span class="ml-4" v-if="dados && dados.paciente_unidade && dados.paciente_unidade.js_classes && dados.paciente_unidade.js_classes.length">
                        <span class="badge badge-success mr-1" v-for="(classe, icx) in dados.paciente_unidade.js_classes" :key="icx">{{ classe }}</span>
                    </span>
                </span>
                <div class="text-muted" v-if="id_atendimento">
                    #{{ id_atendimento }}
                </div>
                <div class="d-flex flex-column flex-md-row" v-if="panel">
                    <span class="text-right"> 
                        <az-paciente-propriedades :paciente="dados"></az-paciente-propriedades>
                    </span>
                    <span class="text-right">
                        <small>
                            <span v-for="(campo, icx) in campos_customizados" :key="icx" :title="campo.label">
                                {{ campo.value }}, 
                            </span>
                            {{ sexo (dados.cadastro.ch_sexo) }}, {{ dados.cadastro.idade }}
                        </small>
                    </span>
                    <span class="ml-3 text-right text-nowrap" v-for="(tel, it) in telefones" :key="it">
                        <i class="fas fa-phone mr-1" v-if="tel.telefone.ch_tipo_telefone == 'R'"></i>
                        <i class="fas fa-mobile-alt mr-1" v-if="tel.telefone.ch_tipo_telefone == 'M'"></i>
                        <small>
                            {{ telefone(tel.telefone) }}
                        </small>
                    </span>
                </div>
            </div>
            <div class="collapse2" id="collapseExample" v-if="show_dados">
                <div class="card-body" v-if="!loading">
                    <div v-if="dados.logo && dados.logo.arquivo" class="mb-2">
                        <!-- <a :href="dados.logo.arquivo.temporary_url" target="_blank"> -->
                        <viewer :images="[paciente.logo.arquivo.temporary_url]">
                            <img :src="dados.logo.arquivo.temporary_url" class="img-fluid img-thumbnail" style="max-width: 200px; max-height: 130px; cursor: pointer;">
                        </viewer>
                    </div>
                    <CadastroPaciente v-model="dados" log_integracao="true" :validate="true" @atualizado="$emit('atualizado')"></CadastroPaciente>
                </div>
            </div>

        </div>

        <template v-if="dados && dados.atendimento_pacotes && dados.atendimento_pacotes.length">
            <pacotes-do-paciente :pacotes="dados.atendimento_pacotes" />
        </template>

        <pre v-if="1 == 0">{{ dados.atendimento_pacotes }}</pre>
        
    </div>
</template>

<script>
import * as moment from 'moment';
import _ from 'lodash';
import CadastroPaciente from './CadastroPaciente.vue';
import AzPacientePropriedades from '../util/AzPacientePropriedades.vue';
import PacotesDoPaciente from './PacotesDoPaciente.vue';

export default {
    data () { 
        return { 
            dados: null,
            loading: true,
            teste: "",
            validar: false, 
            show_dados: false, 
        }
    },
    components: { 
        CadastroPaciente,
        AzPacientePropriedades,
        PacotesDoPaciente,
    },
    props: ['paciente', 'panel', 'id_atendimento', 'plano', 'unidade', 'id_unidade_operacao', 'super_resumo'], 
    watch: {
        $props: {
            handler() {
                this.dados = _.cloneDeep (this.paciente);

                if ( this.id_unidade_operacao ) { 
                    let und = this.$util.unidade_operacao(this.id_unidade_operacao);
                    let cidade_paciente = _.get(this.dados, 'cadastro.endereco.cidade');

                    if ( und && cidade_paciente && und.cidade && und.cidade.id_cidade != cidade_paciente.id_cidade ) { 
                        this.dados.cidade = cidade_paciente;
                    }
                }
            },
            deep: true,
            immediate: true,
        }
    },
    computed: { 
        html_foto: function () { 
            return 'ABC: <strong>Teste</strong>';
            // <img src="' + dados.logo.arquivo.temporary_url + '" />';
        }, 

        campos_customizados: function () { 
            if ( !this.dados.campos_customizados ) { 
                return [];
            }

            return this.dados.campos_customizados.js_campos.filter(campo => campo.label && campo.vc && campo.value);
        },

        telefones: function () { 
            return ( !this.dados.cadastro || !this.dados.cadastro.telefone_cadastros ) 
                ? [] 
                : this.dados.cadastro.telefone_cadastros.filter((item) => { 
                        return item.telefone.st_numero && item.telefone.st_numero.trim ();
                    });
        }
    },

    methods: { 
        get_nome_bb (nome, antes = true) { 
            if ( !nome || typeof nome !== 'string' ) { 
                return nome;
            }

            let partes = nome.split('//');

            if ( partes && partes.length == 1 ) { 
                return antes ? nome : '';
            }

            if ( antes ) { 
                return partes[0].trim();
            } 

            return partes[1] ? partes[1].trim() : '';
        },

        sexo (sexo) {
            return sexo == 'M' ? 'Masculino' : ( sexo == 'F' ? 'Feminino' : '' );
        },

        idade (date) {
            return moment.duration(moment(date, 'YYYY-MM-DD').diff()).humanize();
        },

        telefone (telefone) { 
            if ( telefone.st_cod_pais == '+' ) { 
                return telefone.st_cod_pais + telefone.st_numero;
            }

            let textoAjustado = "(" + telefone.st_numero.slice(0,2) + ") ";
            if(telefone.st_numero.length == 11) {
                const parte1 = telefone.st_numero.slice(2,7);
                const parte2 = telefone.st_numero.slice(7,11);
                textoAjustado = textoAjustado + `${parte1}-${parte2}`        
            } else {
                const parte1 = telefone.st_numero.slice(2,6);
                const parte2 = telefone.st_numero.slice(6,10);
                textoAjustado = textoAjustado + `${parte1}-${parte2}`
            }

            return textoAjustado;
        }
    },

    mounted () { 
        this.loading = false;
        //this.paciente = this.$props.paciente;
    }
}
</script>